import React from "react";
import DoobiHeader from "components/Headers/DoobiHeader";
import AuditLog from "components/Doobi/AuditLog";

const AuditLogRoute = () => (
  <>
    <DoobiHeader section="Activity Log" />
    <AuditLog />
  </>
);

export default AuditLogRoute;
